import React from "react";
import { TimerIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const dark = tone === "dark";
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="flex flex-col items-center" role="timer" aria-label={`Offer ends in ${hours}:${minutes}:${seconds}`} data-id="element-2" data-mp="3c3yysrhwio94">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider sm:text-sm ${dark ? "text-sky" : "text-brand"}`} data-id="element-3" data-mp="323q11989gurm">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-4" data-mp="374vsl3q6qbzk" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-5" data-mp="10a8rg00klju8">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-6" data-mp="159bzltbuk66f" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-7" data-mp="y0n0nmoy559i">
              <span className={`flex h-[68px] w-[68px] items-center justify-center rounded-xl font-display text-[34px] font-bold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${dark ? "bg-white text-ink" : "bg-navy text-white"}`} data-id="element-8" data-mp="xz3jzuzdos77">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/60" : "text-muted"}`} data-id="element-9" data-mp="f1so8kcyggwi">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 text-2xl font-bold sm:pt-5 ${dark ? "text-white/70" : "text-navy"}`} data-id="element-10" data-mp="o4k02l9qteoo">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}